import '../../styles/style.css'

const Phonici = () => {
  return (
    <div className="phoniciContent">
        <h1 className="heading1">Phonici</h1>
        <h2 className="heading2">Android Translation App</h2>
        <p className="descriptionText">Android Translation App supporting text, voice, and image translation using <span className="highlight-text">Google FireBase, Android Studio, and Java.</span></p>

        <div className="social-icons">
            <a target="_blank" href="https://www.linkedin.com/in/derisomalley/details/projects/"><i className='bx bxl-linkedin'></i></a>
            <a target="_blank" href="https://github.com/DerisO22/Phonici"><i className='bx bxl-github'></i></a>
        </div>
        
        {/* <!-- Example Images --> */}
        <h2 className="app_examples_header">From The App</h2>

        <div className="imageExampleContainer">
            <div className="image1_container">
                <img className="example_image1" src="phonici_assets/Phonici_ui_example1.png" alt="Phonici Loading Screen"></img>
                <div className="phonici_example1_overlay">
                    <div className="overlay_text">Loading Screen For Entering Language Category Quiz</div>
                </div>
            </div>
            <div className="image2_container">
                <img className="example_image2" src="phonici_assets/Phonici_ui_example2.webp" alt="Phonici Text Translation Page"></img>
                <div className="phonici_example2_overlay">
                    <div className="overlay_text">Enter text from 51 different languages and translate</div>
                </div>
            </div>
            <div className="image3_container">
                <img className="example_image3" src="phonici_assets/phonici_ui_example3.webp" alt="Phonici Voice Translation Page"></img>
                <div className="phonici_example3_overlay">
                    <div className="overlay_text">Upload/Take a photo and extract text for further translation</div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Phonici;
